import { render, staticRenderFns } from "./AcademyEditUserDialog.vue?vue&type=template&id=56664e61&"
import script from "./AcademyEditUserDialog.vue?vue&type=script&lang=js&"
export * from "./AcademyEditUserDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports